import React, { useState, useEffect } from 'react';
import { checkAdminStatus } from '../services/adminApiService';
import TenantManagement from '../components/admin/TenantManagement';
import PropelOrgManagement from '../components/admin/PropelOrgManagement';
import AdminUserManagement from '../components/admin/AdminUserManagement';
import AuditLogViewer from '../components/admin/AuditLogViewer';
import BackfillPropelIds from '../components/admin/BackfillPropelIds';
import './AdminPage.css';

const AdminPage = () => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [adminUser, setAdminUser] = useState(null);
  const [activeTab, setActiveTab] = useState('tenants');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Check admin status on mount
    checkAdmin();
  }, []);

  async function checkAdmin() {
    try {
      const response = await checkAdminStatus();
      setIsAdmin(response.isAdmin);
      setAdminUser(response.user);
    } catch (error) {
      console.error('Error checking admin status:', error);
      setIsAdmin(false);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  }

  if (loading) {
    return (
      <div className="admin-page-loading">
        <div className="spinner"></div>
        <p>Checking admin access...</p>
      </div>
    );
  }

  if (!isAdmin) {
    return (
      <div className="admin-page-error">
        <div className="error-content">
          <h1>Access Denied</h1>
          <p>Administrative privileges are required to access this page.</p>
          {error && <p className="error-detail">{error}</p>}
          <button onClick={() => window.history.back()} className="back-button">
            Go Back
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-page">
      <div className="admin-header">
        <h1>Admin Console</h1>
        <div className="admin-user-info">
          <span className="admin-label">Admin:</span>
          <span className="admin-name">{adminUser?.displayName || adminUser?.email}</span>
          <span className="admin-role">({adminUser?.role || 'admin'})</span>
        </div>
      </div>

      <div className="admin-tabs">
        <button
          className={`tab-button ${activeTab === 'tenants' ? 'active' : ''}`}
          onClick={() => setActiveTab('tenants')}
        >
          Tenants
        </button>
        <button
          className={`tab-button ${activeTab === 'propel-orgs' ? 'active' : ''}`}
          onClick={() => setActiveTab('propel-orgs')}
        >
          Propel Organizations
        </button>
        <button
          className={`tab-button ${activeTab === 'admin-users' ? 'active' : ''}`}
          onClick={() => setActiveTab('admin-users')}
        >
          Admin Users
        </button>
        <button
          className={`tab-button ${activeTab === 'audit-logs' ? 'active' : ''}`}
          onClick={() => setActiveTab('audit-logs')}
        >
          Audit Logs
        </button>
        <button
          className={`tab-button ${activeTab === 'backfill' ? 'active' : ''}`}
          onClick={() => setActiveTab('backfill')}
        >
          Backfill Propel IDs
        </button>
      </div>

      <div className="admin-content">
        {activeTab === 'tenants' && <TenantManagement />}
        {activeTab === 'propel-orgs' && <PropelOrgManagement />}
        {activeTab === 'admin-users' && <AdminUserManagement adminUser={adminUser} />}
        {activeTab === 'audit-logs' && <AuditLogViewer />}
        {activeTab === 'backfill' && <BackfillPropelIds />}
      </div>
    </div>
  );
};

export default AdminPage;
